








































































import {
  Component, Mixins, Prop,
} from 'vue-property-decorator';
import Entity from '@/views/Entity.vue';
import { State } from 'vuex-class';
import { CrudOperation } from '@/types/CrudOperation';
import { Roles } from '@/store/profile/types';
import UserMixin from '@/mixins/UserMixin';
import {
  gte, lte, like, and, or, not, exact,
} from '@/classes/pimcore-filtering/Filters';
import FilterBuilder from '@/classes/pimcore-filtering/FilterBuilder';
import ApplicationHRForm from '@/components/ApplicationHR/ApplicationHRForm.vue';
import CreationForm from '@/components/ApplicationHR/CreationForm.vue';
import ApplicationHRPreview from '@/components/ApplicationHR/ApplicationHRPreview.vue';
import ReadForm from '@/components/ApplicationHR/ReadForm.vue';
import EntityFilters from '@/components/Entity/EntityFilters.vue';
import DateFilter from '@/components/common/DateFilter.vue';
import EntityHelperMixin from '@/mixins/EntityHelperMixin';
import NormalizerMixin from '@/mixins/NormalizerMixin';

@Component({
  components: {
    ApplicationHRPreview,
    Entity,
    ApplicationHRForm,
    CreationForm,
    ReadForm,
    EntityFilters,
    DateFilter,
  },
})
export default class ApplicationHR extends Mixins(UserMixin, EntityHelperMixin, NormalizerMixin) {
  CREATING_ENTITY = 'GeneralApplication' as const;

  @Prop({
    type: String,
    required: false,
    default: 'ApplicationHR',
  }) readonly localStoragePrefix!: string

  filters: any = null;

  loading = true;

  extendedFilters = ['ids', 'date_from', 'date_to'];

  idsFilter = '';

  customByObject: any = null;

  coordinatorRole: any = null;

  @State('operation', { namespace: 'entity' })
  operation!: CrudOperation;

  formData: Record<string, any> | null = null;

  formOptions: Record<string, any[]> | null = null;

  async beforeMount() {
    this.idsFilter = this.getFromStorage('ids');
    this.filters = await this.getFilters();
    this.customByObject = this.getCustomByObject();
    this.coordinatorRole = (await this.loadRoles()).find((v: any) => v.role_type === Roles.COORDINATOR);
    this.loading = false;
    this.$bus.$on('preview', (formData: Record<string, any>) => {
      this.formData = formData.data;
      this.formOptions = formData.options;
    });
    this.$bus.$on('clear-filters', () => {
      this.idsFilter = '';
      this.setToStorage('ids', '');
    });
  }

  gte = (type: string, value: string) => gte(type, value)

  lte = (type: string, value: string) => lte(type, value)

  get getOnlyFilters() {
    if (this.isCoordinator) {
      return ['id', 'date_from', 'date_to', 'status', 'client', 'platform', 'Supplier', 'coordinator'];
    }
    if (this.isHR) {
      return ['id', 'date_from', 'date_to', 'status', 'client', 'platform', 'Supplier', 'coordinator'];
    }
    if (this.isSupplier) {
      return ['id', 'date_from', 'date_to', 'status', 'client', 'platform', 'coordinator'];
    }
    return [];
  }

  get getComplexFiltersVariables() {
    const variables: any = {
      platform: {},
      client: {},
      Supplier: {},
      coordinator: {},
    };

    let filterBuilder;
    if (this.userPlatformIds.length > 0) {
      filterBuilder = new FilterBuilder();
      let ors: any[] = this.userPlatformIds.map((platformId: number) => exact('oo_id', platformId));
      filterBuilder.addFilters(or(...ors));
      variables.platform.filter = filterBuilder.build();

      filterBuilder = new FilterBuilder();
      ors = this.userPlatformIds.map((platformId: number) => like('Plants', `%${platformId}%`));
      filterBuilder.addFilters(or(...ors));
      variables.client.filter = filterBuilder.build();

      filterBuilder = new FilterBuilder();
      ors = this.userPlatformIds.map((platformId: number) => like('PlantsHR', `%${platformId}%`));
      filterBuilder.addFilters(or(...ors));
      variables.Supplier.filter = filterBuilder.build();

      filterBuilder = new FilterBuilder();
      ors = this.userPlatformIds.map((platformId: number) => like('PlantsHR', `%${platformId}%`));
      filterBuilder.addFilters(and(or(...ors), exact('role__id', this.coordinatorRole.id)));
      variables.coordinator.filter = filterBuilder.build();
    } else {
      filterBuilder = new FilterBuilder();
      filterBuilder.addFilters(exact('oo_id', 0));
      variables.platform.filter = filterBuilder.build();
      variables.client.filter = filterBuilder.build();
      variables.Supplier.filter = filterBuilder.build();
      variables.coordinator.filter = filterBuilder.build();
    }

    return variables;
  }

  get getOnlyColumns() {
    if (this.isCoordinator) {
      return ['id', 'creationDate', 'date_from', 'date_to', 'status', 'client', 'platform', 'coordinator', 'Supplier', 'summaryQuantityDay', 'summaryQuantityNight', 'day_comment', 'night_comment'];
    }
    if (this.isHR) {
      return ['id', 'creationDate', 'date_from', 'date_to', 'status', 'client', 'platform', 'coordinator', 'Supplier', 'summaryQuantityDay', 'summaryQuantityNight', 'day_comment', 'night_comment'];
    }
    if (this.isSupplier) {
      return ['id', 'creationDate', 'date_from', 'date_to', 'status', 'client', 'platform', 'coordinator', 'summaryQuantityDay', 'summaryQuantityNight', 'day_comment', 'night_comment'];
    }
    return [];
  }

  getCustomByObject() {
    return {
      id: '',
      creationDate: '',
      date_from: '',
      date_to: '',
      status: {
        id: '',
        name: '',
        code: '',
      },
      client: {
        id: '',
        legal_name: '',
      },
      platform: {
        id: '',
        name: '',
      },
      coordinator: {
        id: '',
        email: '',
        full_name: '',
      },
      Supplier: {
        id: '',
        legal_name: '',
        fact_name: '',
      },
      summaryQuantityDay: '',
      summaryQuantityNight: '',
      jbpm_process_id: '',
      jbpm_container_id: '',
      medical_book: '',
      day_comment: '',
      night_comment: '',
      operationWorks: {
        id: '',
        date: '',
        time_from: '',
        time_to: '',
        time_interval: '',
        workType: {
          ...this.getNormalizerRequiredFields('Work'),
        },
        size: '',
        quantity: '',
        category: '',
        technology: '',
        PC: '',
        comment: '',
        actual_quantity: '',
        actual_size: '',
        actual_work_time: '',
        performance: '',
        quality: '',
        units: {
          ...this.getNormalizerRequiredFields('Units'),
        },
      },
    };
  }

  async loadUsersWithSuperior(superior_id: string) {
    if (!superior_id) {
      return [];
    }

    const filterBuilder = new FilterBuilder();
    filterBuilder.addFilters(and(like('superior__id', superior_id)));

    const users = await this.loadEntityListing('User', {
      filter: filterBuilder.build(),
    });
    return users.map((item: any) => item.id);
  }

  async getStatusID(code: string) {
    return (await this.loadEntityListing('StatusApplication')).find((v: any) => v.code === code)?.id;
  }

  async loadRoles() {
    return this.loadEntityListing('Role', {}, 'network-only', { maxDepth: 1 });
  }

  get isCreate() {
    return this.operation === CrudOperation.create;
  }

  get title() {
    return this.$t('ApplicationHR_my_plural');
  }

  async getFilters() {
    const filtersArray = [];
    if (this.isSupplier) {
      const supplierId = this.pimcoreUser?.supplier_id;
      if (supplierId) {
        filtersArray.push(and(like('supplier__id', supplierId)));
      }
      filtersArray.push(and(not('status__id', await this.getStatusID('created'))));
    }
    if (this.userPlatformIds.length > 0) {
      const ors: any[] = this.userPlatformIds.map((platformId: number) => exact('platform__id', platformId));
      filtersArray.push(or(...ors));
    } else {
      filtersArray.push(exact('platform__id', 0));
    }
    return filtersArray;
  }
}

